import gql from "graphql-tag";

export const OPTIONS_PENDING_REMODERATION_QUERY = gql`
  fragment RemoderationImageFragment on Image {
    id
    sourceUrl
    deletedAt

    nextImage {
      id
      nesImageId
      imageUrl
      originalUrl
      status
    }
  }

  query OptionsPendingRemoderation($count: Int!) {
    moderationOptions: optionsPendingRemoderation(count: $count) {
      id
      status
      resolveAction

      imageBroken
      hasBackground
      containsLogo
      containsText
      logoCoversProduct

      option {
        id

        entities {
          entity
          value
        }

        product {
          id
          sourceName
          sourceUrl

          images {
            ...RemoderationImageFragment
          }
        }
      }

      image {
        id
        nesImageId
        status
        url
      }
    }
  }
`;

export {
  OptionsPendingRemoderation,
  OptionsPendingRemoderationVariables,
  OptionsPendingRemoderation_moderationOptions as IModerationOption,
  OptionsPendingRemoderation_moderationOptions_option_product_images as IProductImage
} from "~/graphql/types";



// WEBPACK FOOTER //
// ./src/graphql/queries/optionRemoderation/optionsPendingRemoderation.ts